import { useQueryWithUserId } from '@northladder/services';

import { B2B_SERVICE_API } from '../b2bApiClient';

/**
 * To track the cache key entry for all admin requests listing.
 */
const FETCH_ALL_ADMIN_REQUESTS_KEY = 'fetch-all-admin-requests-key';

/**
 * It fetches the auto assessments requests list data, also takes in the payload
 * for filters, search key mapping, sorting, pagination etc.
 *
 * @deprecated - This is currently used. To be revisited later.
 */
export const useAllAdminRequestsListQuery = () => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [FETCH_ALL_ADMIN_REQUESTS_KEY],
    queryFn: () => B2B_SERVICE_API.fetchAllAdminRequestsList({ pageSize: 20 }),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
